/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Expand: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2929 10.2929C12.6834 9.90237 13.3166 9.90237 13.7071 10.2929L18 14.5858L22.2929 10.2929C22.6834 9.90237 23.3166 9.90237 23.7071 10.2929C24.0976 10.6834 24.0976 11.3166 23.7071 11.7071L18.7071 16.7071C18.5196 16.8946 18.2652 17 18 17C17.7348 17 17.4804 16.8946 17.2929 16.7071L12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929Z'
      fill='currentColor'
    />
  </React.Fragment>
)
